if (module.hot) {
  module.hot.accept();
}
require('./cursor');
require('./custom');
require('./slider');
require('./menu');
require('./animation');
require('./popup');
// import 'bootstrap';
